import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class EmailVerifyGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | Promise<boolean> {
    const token = route?.params?.token?.trim().length > 0;
    if (token) {
      return true;
    }
    return this.router.navigate(['login']);
  }
}